import { isSiDaProperty } from '@merchant-backend/util'
import { Checkbox, Modal } from 'hljd'
import React, { Component } from 'react'
import styles from './style.module.less'

// 付款方式自定义组件
export default class extends Component {
  onChange = value => {
    let newValue = '1'
    if (value.includes('2') || value.includes(2)) {
      newValue = '2'
    }
    this.props.onChange(newValue)
  }

  render() {
    let { value, disabled } = this.props
    value = value == '2' ? ['pay_all', '2'] : ['pay_all']
    return (
      <Checkbox.Group
        disabled={disabled}
        value={value}
        onChange={this.onChange}
        options={[
          { label: '全款支付', value: 'pay_all', disabled: true },
          { label: isSiDaProperty() ? '订金支付' : '定金支付', value: '2' }
        ]}
      />
    )
  }
}

export function PayWayModal(props) {
  const { visible, onCancel } = props
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title="订单支付须知"
    >
      <div className={styles.wrapper}>
        <div className={styles.center}>婚礼纪订单付款及退款协议</div>
        <div className={styles.center}>（2020年2月版本）</div>
        <p>
          为保护婚礼纪用户、商家、婚礼纪以及其他任何可能存在利害关系的第三方的合法权益，依照《中华人民共和国合同法》等法律法规，特制定本协议。
        </p>
        <p>
          您在注册、使用婚礼纪提供的各项服务（包括但不限于通过婚礼纪平台购买服务或商品、通过婚礼纪平台从事服务提供或商品提供）之前，应确保您已经充分阅读、理解并同意本协议项下所有条款。如果您不同意下述条款或对下述条款存在任何疑问，请立即停止使用婚礼纪提供的各项服务并/或就您的疑问向婚礼纪平台客服人员予以咨询。
        </p>
        <p className={styles.bold}>1.本协议的名词解释</p>
        <p>
          1.1“平台”，是指杭州火烧云科技公司运营的婚礼纪电子商务平台，包括婚礼纪app、婚礼纪网页等;
        </p>
        <p>
          1.2
          “用户”，是指在婚礼纪平台注册并通过婚礼纪平台接受婚礼纪服务的自然人（买家）；
        </p>
        <p>
          1.3
          “商家”，是指入驻婚礼纪平台/在婚礼纪平台注册，从事婚礼相关服务或者婚品等商品销售的经营者；
        </p>
        <p>
          1.4
          “用户支付渠道”，是指用户支付订单时所使用的账户，包括但不限于网银、支付宝、微信支付等账户；
        </p>
        <p>
          1.5
          “不可抗力”，是指当事人不能预见、不能避免并不能克服的客观情况，包括但不限于自然灾害（如台风、地震、洪水、冰雹）、政府行为（如征收、征用）、社会异常事件（如罢工、骚乱）等。
        </p>
        <p className={styles.bold}>2.订金支付</p>
        <p>
          用户在购买商家提供的服务或商品时，需支付一定数额的订金作为服务、商品的预付款，具体金额以用户最终所支付的订金金额为准，若用户在购买服务时通过本平台一次性全额付款的，服务、商品全额价款的30%将被视为用户购买服务、商品所支付的订金。
        </p>
        <p>
          3.
          订金支付后，用户可向平台申请退款、取消预定，商家亦可取消用户的预定。预定取消后，可退订金与退款流程按以下条款执行。
        </p>
        <p>
          3.1.在用户支付订金后，商家确认接单前用户可随时申请退款、取消预定，订金将于用户申请之日起7个工作日内返还至用户支付渠道。
        </p>
        <p>
          3.2在用户支付订金且商家确认接单后，由于用户个人原因，导致商家无法向用户提供约定的服务、商品
        </p>
        <p>
          3.2.1用户理解并同意：由于婚礼行业的特殊性，为在约定的服务（或商品的交付日期）日期向用户提供高效、优质的服务或商品，商家需要在约定日期前便做好充足的准备，在此过程中，商家需要花费特定的人力、物力等成本。
        </p>
        <p>
          3.2.2基于此，因用户个人原因，导致商家无法向用户提供约定的服务、商品的，将扣除一定比例的订金作为赔偿金支付给商家：
        </p>
        <p>
          3.2.2.1距离用户与商家约定的提供服务或交付商品的日期30天以内（包含30天）的，用户发起退款的，将扣除订金金额的100%；
        </p>
        <p>
          3.2.2.2距离用户与商家约定的提供服务或交付商品的日期超过30天不足90天的，用户发起退款，将扣除订金金额的50%；
        </p>
        <p>
          3.2.2.3距离用户与商家约定的提供服务或交付商品的日期超过90天以上的，用户发起退款，无须向商家支付赔偿金。但及涉试妆费用及或其他成本已发生的，商户可扣除相应费用，具体由商家和用户自主协商。
        </p>
        <p>
          3.2.3剩余订金金额将于用户申请退款之日起7个工作日内退还至用户支付渠道。
        </p>
        <p>
          3.3在用户支付订金且商家确认接单后，由于商家个人原因，导致其无法按约定向用户提供服务、商品
        </p>
        <p>
          3.3.1商家主动发起退款的，用户所支付的订金将于商家主动发起订金退款之日起7个工作日全额返还用户支付渠道；
        </p>
        <p>
          3.3.2商家未主动申请向用户退款，用户可根据本协议以及相应规定向平台申请退款，退款金额将于平台审核通过之日起7个工作日返还至用户支付渠道。
        </p>
        <p>
          3.4在用户支付订金且商家确认接单后，由于不可抗力导致商家未按双方约定向用户提供服务或交付商品/用户未按双方约定接受商家所提供的服务、商品的双方都可根据本协议及相应规定向平台申请退还订金，退款金额将于平台审核通过之日起7个工作日返还至用户支付渠道。
        </p>
        <p>
          3.5在用户支付订金且商家已经提供服务、商品，但用户认为商家提供的服务、商品不符合中国法律法规及双方约定的，订金的退还金额及流程，由双方予以协商，协商不一致的，平台将依据《婚礼纪用户与商家争议处理规则》及相关规则予以处理。
        </p>
        <p>
          3.6一次性全额付款的订金退款金额、流程<br />用户在购买服务、商品时通过本平台一次性支付全额价款的，订金按全额价款的30%计算，在此基础上该部分可退还金额及退款流程根据实际情况执行本协议的相应条款。
        </p>
        <p className={styles.bold}>4.尾款的退还</p>
        <p>4.1尾款的金额</p>
        <p>
          尾款的金额以商家与用户后续通过本平台实际支付的尾款金额为准。<br />用户在购买服务、商品时通过本平台一次性支付全额价款的，尾款按全额价款的70%计算并执行相应条款。
        </p>
        <p>
          4.2尾款退还的具体流程[烦请对该部分进行确认：（1）由于本协议为付款协议，故除订金外还涉及尾款的退款问题，烦请确认是否需要在协议中包含尾款的退款问题；（2）若确认需要包含该部分内容，公司可根据公司实际执行的退款政策对该部分进行修改调整。]
        </p>
        <p>
          4.2.1商家未向用户提供服务<br />尾款将于商家主动发起退款/平台审核通过之日起7个工作日全额返还至用户支付渠道。
        </p>
        <p>4.2.2商家已向用户提供服务</p>
        <p>
          4.2.2.1商家主动发起退款的，尾款将于商家主动发起退款之日起7个工作日全额返还至用户支付渠道。
        </p>
        <p>
          4.2.2.2用户申请退款的且双方协商一致的，尾款将于平台审核之日起7个工作日全额返还至用户支付渠道。双方协商不一致的，依照《婚礼纪用户与商家争议处理规则》及相关规则处理。
        </p>
        <p>
          5.平台仅受理用户在购买服务、商品时通过本平台所支付的款项的退款问题，用户未通过平台而直接向商家付款的退款问题，由用户与商家自行协商解决。
        </p>
        <p>6.证明材料的提供</p>
        <p>
          6.1
          商家主动发起退款的，用户无须向平台提供证明材料，因情况特殊需要由用户举证的除外；
        </p>
        <p>
          6.2用户申请退款的，应当向平台客服提供相关证明材料证明情况属实，证明材料包括但不限于聊天记录截图、合同截图、录音录像、转账记录、订单记录等;商家对用户提供的材料不认可，可向平台客服提供证明材料及有关说明，平台将依据《婚礼纪用户与商家争议处理规则》及相关规则予以处理。
        </p>
        <p>7.其他</p>
        <p>
          订单付款及退款时产生的其他问题，依照本平台制定的相关您需要定期查看本平台制定的相关规则、协议、办法、须知、通知、公示等等进行处理。您需要关注本平台已经制定以及在您使用本平台期间制定的相关规则、协议、办法、须知、通知、公示等。
        </p>
      </div>
    </Modal>
  )
}
